import actionTypes from './actionTypes';

export const mapElementDrop = payload => ({
    type: actionTypes.MAP_ELEMENT_DROP,
    payload,
});

export const escapeKeyPress = flowId => ({
    type: actionTypes.GRAPH_ESCAPE_KEY,
    payload: flowId,
});
